import { useState } from 'react';
import { Button, Checkbox, Typography } from 'seagull';
import { StepPage } from "../../components/StepPage";
import AccountantAccessLearnMoreButton from "../../../components/AccountantAccessLearnMoreButton";
import { RequestAccountantAccess } from "../../../models/request-accountant-access";
import { useCobStorage } from "../CobStorageContext";
import styles from "./AccountantAccessStep.module.scss";
import { COBStep, getStepName } from "../ClientOnboarding.utils";
import { useCobConfig } from "../CobConfigContext";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function AccountantAccessStep(props) {
  const {
    onDone,
    onBack
  } = props;
  const {
    relationship
  } = useCobConfig();
  const {
    getFromStorage,
    setToStorage
  } = useCobStorage(relationship);
  const [checked, setChecked] = useState(() => getFromStorage('request_accountant_access') || false);
  const isNextDisabled = relationship.requestAccountantAccess === RequestAccountantAccess.Mandatory && !checked;
  return /*#__PURE__*/_jsx(StepPage, {
    header: getStepName(COBStep.accountantAccess),
    primaryBtn: /*#__PURE__*/_jsx(Button, {
      disabled: isNextDisabled,
      tooltip: {
        title: isNextDisabled ? 'To approve this proposal, Accountant Access permissions must be granted' : ''
      },
      "data-testid": "accountant-access-next-btn",
      onClick: onDone,
      children: "Next"
    }),
    onBackBtnClick: onBack,
    children: /*#__PURE__*/_jsxs("div", {
      "data-testid": "accountant-access-page",
      className: styles.container,
      children: [/*#__PURE__*/_jsxs(Typography, {
        children: ["Accountant Access will allow the ", relationship.vendor.name, " team to view your account information on Anchor, including invoices, agreements, and payments, as well as manage your payment methods."]
      }), /*#__PURE__*/_jsx(Checkbox, {
        "data-testid": "accountant-access-checkbox",
        checked: checked,
        onChange: e => {
          const newChecked = e.target.checked;
          setChecked(newChecked);
          setToStorage('request_accountant_access', newChecked);
        },
        children: /*#__PURE__*/_jsxs(Typography, {
          children: ["I grant Accountant Access to ", relationship.vendor.name]
        })
      }), /*#__PURE__*/_jsx(AccountantAccessLearnMoreButton, {
        isVendor: false
      })]
    })
  });
}